<template>
    <div class="flex items-center gap-6 scaffold-body-small text-ink">
        <span class="flex items-center gap-2.5"><span class="swatch bg-assessment-others"></span> {{ t("assessments.results.scoreLegend.ratedByOthers") }}</span>
        <span class="flex items-center gap-2.5">
            <span class="swatch bg-assessment-self"></span>
            {{ subjectName ? t("assessments.results.scoreLegend.subjectSelfRating", { subjectName }) : t("assessments.results.scoreLegend.yourSelfRating") }}
        </span>
    </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";

interface Props {
    // Set when someone other than the subject (a team lead) is viewing;
    // switches the label to third person.
    subjectName?: string;
}

defineProps<Props>();

const { t } = useI18n();
</script>

<style scoped>
@reference "../../../css/tailwind.css";

@layer components {
    .swatch {
        @apply w-2.5 h-2.5 rounded-xs shrink-0;
    }
}
</style>
